import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIPreferencesStore {
  isDebugToolbarVisible: boolean;
  isDebugToolbarExpanded: boolean;

  toggleDebugToolbar: () => void;
  setDebugToolbarExpanded: (expanded: boolean) => void;
  hideDebugToolbar: () => void;
  showDebugToolbar: () => void;
}

export const useUIPreferencesStore = create<UIPreferencesStore>()(
  persist(
    (set) => ({
      // Default: HIDDEN
      isDebugToolbarVisible: false,
      isDebugToolbarExpanded: false,

      toggleDebugToolbar: () =>
        set((state) => ({ isDebugToolbarVisible: !state.isDebugToolbarVisible })),

      setDebugToolbarExpanded: (expanded: boolean) =>
        set({ isDebugToolbarExpanded: expanded }),

      hideDebugToolbar: () => set({ isDebugToolbarVisible: false }),
      showDebugToolbar: () => set({ isDebugToolbarVisible: true }),
    }),
    {
      name: 'ui-preferences-storage',
      partialize: (state) => ({
        isDebugToolbarVisible: state.isDebugToolbarVisible,
        isDebugToolbarExpanded: state.isDebugToolbarExpanded,
      }),
    }
  )
);
